// Synthesize transition sounds using Web Audio API
// No external files or APIs required

let audioContext: AudioContext | null = null;

const getAudioContext = (): AudioContext => {
  if (!audioContext) {
    audioContext = new AudioContext();
  }
  return audioContext;
};

export const playWhooshSound = (type: "enter" | "exit" = "enter", volume: number = 0.5) => {
  const ctx = getAudioContext();
  const now = ctx.currentTime;
  
  // Create noise source for whoosh texture
  const bufferSize = ctx.sampleRate * 0.8;
  const noiseBuffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
  const noiseData = noiseBuffer.getChannelData(0);
  
  for (let i = 0; i < bufferSize; i++) {
    noiseData[i] = Math.random() * 2 - 1;
  }
  
  const noiseSource = ctx.createBufferSource();
  noiseSource.buffer = noiseBuffer;
  
  // Bandpass filter for whoosh character
  const filter = ctx.createBiquadFilter();
  filter.type = "bandpass";
  filter.Q.value = 1.5;
  
  // Frequency sweep for movement effect
  if (type === "enter") {
    filter.frequency.setValueAtTime(200, now);
    filter.frequency.exponentialRampToValueAtTime(2000, now + 0.3);
    filter.frequency.exponentialRampToValueAtTime(800, now + 0.6);
  } else {
    filter.frequency.setValueAtTime(1500, now);
    filter.frequency.exponentialRampToValueAtTime(300, now + 0.4);
  }
  
  // Gain envelope for smooth attack/decay
  const gainNode = ctx.createGain();
  const peakVolume = volume * 0.3;
  
  if (type === "enter") {
    gainNode.gain.setValueAtTime(0, now);
    gainNode.gain.linearRampToValueAtTime(peakVolume, now + 0.08);
    gainNode.gain.exponentialRampToValueAtTime(0.001, now + 0.6);
  } else {
    gainNode.gain.setValueAtTime(peakVolume * 0.8, now);
    gainNode.gain.exponentialRampToValueAtTime(0.001, now + 0.5);
  }
  
  // Add subtle low-frequency oscillator for depth
  const lfo = ctx.createOscillator();
  const lfoGain = ctx.createGain();
  lfo.frequency.value = type === "enter" ? 80 : 60;
  lfoGain.gain.setValueAtTime(0, now);
  lfoGain.gain.linearRampToValueAtTime(volume * 0.1, now + 0.1);
  lfoGain.gain.exponentialRampToValueAtTime(0.001, now + 0.4);
  
  // Connect nodes
  noiseSource.connect(filter);
  filter.connect(gainNode);
  gainNode.connect(ctx.destination);
  
  lfo.connect(lfoGain);
  lfoGain.connect(ctx.destination);
  
  // Start and stop
  noiseSource.start(now);
  noiseSource.stop(now + 0.7);
  lfo.start(now);
  lfo.stop(now + 0.5);
};
